"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var DropdownHeader = function DropdownHeader(props) {
  var icon = props.icon,
      label = props.label,
      center = props.center;
  return /*#__PURE__*/_react.default.createElement("li", {
    className: "dropdown-header ".concat(center ? 'center' : '')
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'dropdown-header-text'
  }, icon && /*#__PURE__*/_react.default.createElement("span", {
    className: 'margin-right-5'
  }, icon), label));
};

DropdownHeader.defaultProps = {
  center: true
};
DropdownHeader.propTypes = {
  icon: _propTypes.default.string,
  center: _propTypes.default.bool,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};
var _default = DropdownHeader;
exports.default = _default;